module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/GtCUA6/Images/cover.jpg?1684514527813",
      "alt": "This image is the cover for the book Una promessa rispettata, Serie Scelta del cuore"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Una promessa rispettata, Serie Scelta del cuore\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Seguito di Legame di Fiducia"), _c('br'), _vm._v("Serie Scelta del cuore, Libro 3")])])]), _c('p', [_vm._v("Jin Rayne si sta ancora abituando ai suoi terrificanti nuovi poteri di pantera nekhene e al suo ruolo di reah della tribù di Logan Church, quando viene a sapere che è stato convocato un sepat: una sfida d’onore. Logan, che non ha mai voluto far altro che guidare la sua piccola tribù, deve andare dall’altra parte del mondo, in Mongolia, e combattere per diventare il più potente leader di pantere mannare del mondo.")]), _vm._v(" "), _c('p', [_vm._v("Logan non sarà l’unico ad affrontare quel viaggio: essendo il suo compagno, Jin deve lottare al suo fianco per onorare il suo impegno verso Logan, la sua cultura e la sua tribù. Ma la prova è lunga e prevede che i due uomini restino separati a lungo: l’umanità di Logan è in gioco. Per superare il terribile sepat, Jin e Logan devono accettare il loro fato, fidarsi l’uno dell’altro, e rispettare le promesse che si sono fatti, costi quel che costi.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mary Calmes, Cornelia Grey\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0